module.exports = __webpack_public_path__ + "imgs/no-reviews.b664351c63627e1649d5b33cc570a568.webp";